import { Preferences } from '@capacitor/preferences';
import type { AuthTokens } from '@/types/api';
import { isNative } from './platform';

const ACCESS_KEY = 'heritage.accessToken';
const REFRESH_KEY = 'heritage.refreshToken';

let accessToken: string | null = null;
let refreshToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function getRefreshToken(): string | null {
  return refreshToken;
}

export async function restoreTokens(): Promise<AuthTokens | null> {
  if (!isNative()) return null;
  const [access, refresh] = await Promise.all([
    Preferences.get({ key: ACCESS_KEY }),
    Preferences.get({ key: REFRESH_KEY }),
  ]);
  accessToken = access.value;
  refreshToken = refresh.value;
  return access.value && refresh.value
    ? { accessToken: access.value, refreshToken: refresh.value }
    : null;
}

export async function saveTokens(tokens: AuthTokens): Promise<void> {
  accessToken = tokens.accessToken;
  refreshToken = tokens.refreshToken;
  if (!isNative()) return;
  await Promise.all([
    Preferences.set({ key: ACCESS_KEY, value: tokens.accessToken }),
    Preferences.set({ key: REFRESH_KEY, value: tokens.refreshToken }),
  ]);
}

export async function clearTokens(): Promise<void> {
  accessToken = null;
  refreshToken = null;
  if (!isNative()) return;
  await Promise.all([
    Preferences.remove({ key: ACCESS_KEY }),
    Preferences.remove({ key: REFRESH_KEY }),
  ]);
}
